/**
 * [allCntsName description]
 * @param  {array}   arr   the output of allCnts function
 * @return {array}         an array holding all the countries name
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.allCntsName = allCntsName;

function allCntsName(arr) {
  var output = [];
  arr.forEach(function (d) {
    if (d.name !== 'Rest of the world') output.push(d.name);
  });
  output.unshift('All');
  return output;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvYWxsQ250c05hbWUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBS08sU0FBUyxXQUFXLENBQUMsR0FBRyxFQUFDO0FBQzlCLE1BQUksTUFBTSxHQUFHLEVBQUUsQ0FBQTtBQUNmLEtBQUcsQ0FBQyxPQUFPLENBQUMsVUFBQyxDQUFDLEVBQUc7QUFDZixRQUFHLENBQUMsQ0FBQyxJQUFJLEtBQUssbUJBQW1CLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUE7R0FDdkQsQ0FBQyxDQUFBO0FBQ0YsUUFBTSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQTtBQUNyQixTQUFPLE1BQU0sQ0FBQTtDQUNkIiwiZmlsZSI6Ii9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvYWxsQ250c05hbWUuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFthbGxDbnRzTmFtZSBkZXNjcmlwdGlvbl1cbiAqIEBwYXJhbSAge2FycmF5fSAgIGFyciAgIHRoZSBvdXRwdXQgb2YgYWxsQ250cyBmdW5jdGlvblxuICogQHJldHVybiB7YXJyYXl9ICAgICAgICAgYW4gYXJyYXkgaG9sZGluZyBhbGwgdGhlIGNvdW50cmllcyBuYW1lXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBhbGxDbnRzTmFtZShhcnIpe1xuICBsZXQgb3V0cHV0ID0gW11cbiAgYXJyLmZvckVhY2goKGQpPT57XG4gICAgaWYoZC5uYW1lICE9PSAnUmVzdCBvZiB0aGUgd29ybGQnKSBvdXRwdXQucHVzaChkLm5hbWUpXG4gIH0pXG4gIG91dHB1dC51bnNoaWZ0KCdBbGwnKVxuICByZXR1cm4gb3V0cHV0XG59Il19